import customConfirmationPorto from "../../../../src/content/portugal-celebrationofhope/customConfirmation";
import { GetInvolved } from '@bgea-js/form-templates';
import "../../../../src/content/portugal-celebrationofhope/portopt.scss";
import * as React from 'react';
export default {
  customConfirmationPorto,
  GetInvolved,
  React
};